import React from 'react';
import { Accordion, Nav } from 'react-bootstrap';
import {
  Dashboard as DashboardIcon,
  Inventory as ProductIcon,
  LocalOffer as OfferIcon,
  Business as EntityIcon,
  Visibility as ViewIcon,
  Add as AddIcon,
  Assignment as RequirementIcon,
} from '@mui/icons-material';
import { LocalShipping as LocalShippingIcon, Public as PublicIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

// Add custom CSS to style the accordion arrow
const CustomAccordionStyles = styled('div')(() => ({
  '& .accordion-button::after': {
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 9.293l5.646-5.353a.5.5 0 0 1 .708.708l-6 5.5a.5.5 0 0 1-.708 0l-6-5.5a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E") !important`,
  },
  '& .accordion-button:not(.collapsed)::after': {
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3E%3Cpath fill-rule='evenodd' d='M1.646 11.646a.5.5 0 0 0 .708 0L8 6.293l5.646 5.353a.5.5 0 0 0 .708-.708l-6-5.5a.5.5 0 0 0-.708 0l-6 5.5a.5.5 0 0 0 0 .708z'/%3E%3C/svg%3E") !important`,
  },
  '& .accordion-button': {
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
    padding: '2px 5px 2px 0',
  },
}));

const SidebarCommon = ({ selectedFilter, handleDataFilterChange }) => {
  const topOptions = [
    { value: '', label: 'Dashboard', icon: <DashboardIcon /> },
    { value: 'products', label: 'Products', icon: <ProductIcon /> },
    { value: 'offers', label: 'Offers', icon: <OfferIcon /> },
    { value: 'entities', label: 'Entities', icon: <EntityIcon /> },
  ];

  const requirementOptions = [
    { value: 'Requirement Approval', label: 'View', icon: <ViewIcon /> },
    { value: 'Add Requirement', label: 'Add', icon: <AddIcon /> },
  ];


  const masterOptions = [
    // { value: 'Product Category', label: 'Product Category', icon: <PublicIcon /> },
    { value: 'Product', label: 'Product List', icon: <PublicIcon /> },
    { value: 'Product Offers', label: 'Product Offers Charges', icon: <OfferIcon /> },
    { value: 'Inland Shipping', label: 'Transport & Shipping', icon: <LocalShippingIcon /> },
    { value: 'Country wise Product', label: 'Country wise Product', icon: <PublicIcon /> },
  ];

  const handleClick = (value) => {
    const event = { target: { value } };
    handleDataFilterChange(event);
  };

  const NavLinkWrapper = styled('span')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: '13px 0 13px 15px',
    cursor: 'pointer',
    fontSize: '13px',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.active': {
      backgroundColor: theme.palette.action.selected,
      fontWeight: theme.typography.fontWeightBold,
      color: 'rgb(222, 107, 20) !important',
      '& .MuiSvgIcon-root': {
        color: 'rgb(222, 107, 20)',
      },
      '&.requirement-item': {
        color: '#ffffff',
      },
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
  }));

  const AccordionHeaderWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: '8px 13px',
    fontSize: '14px',
    color: '#ffffff',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '& .MuiSvgIcon-root': {
      color: '#ffffff !important',
    },
  }));

  return (
    <aside
      className="left-panel text-white"
      style={{ width: '250px', backgroundColor: '#2c3e50' }}
    >
      <div className="offers-filter-options">
        <ul className="nav flex-column">
          {/* Render Dashboard */}
          <li
            key={topOptions[0].value}
            className={`nav-item ${selectedFilter === topOptions[0].value ? 'active' : ''}`}
            onClick={() => handleClick(topOptions[0].value)}
          >
            <NavLinkWrapper className={selectedFilter === topOptions[0].value ? 'active' : ''}>
              {topOptions[0].icon}
              <span>{topOptions[0].label}</span>
            </NavLinkWrapper>
          </li>

          {/* Master Accordion */}
          <CustomAccordionStyles>
            <Accordion defaultActiveKey="0" className="mt-3">
              <Accordion.Item eventKey="0" className="bg-transparent border-0">
                <Accordion.Header className="accord-text">
                  <AccordionHeaderWrapper>
                    <ProductIcon />
                    <span>Master</span>
                  </AccordionHeaderWrapper>
                </Accordion.Header>
                <Accordion.Body className="p-0">
                  <Nav className="flex-column">
                    {masterOptions.map((option) => (
                      <li
                        key={option.value}
                        className={`nav-item ${selectedFilter === option.value ? 'active' : ''}`}
                        onClick={() => handleClick(option.value)}
                      >
                        <NavLinkWrapper
                          className={`ps-4 requirement-item ${
                            selectedFilter === option.value ? 'active' : ''
                          }`}
                        >
                          {option.icon}
                          <span>{option.label}</span>
                        </NavLinkWrapper>
                      </li>
                    ))}
                  </Nav>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </CustomAccordionStyles>

          {/* Render remaining topOptions (Products, Offers, Entities) */}
          {topOptions.slice(1).map((option) => (
            <li
              key={option.value}
              className={`nav-item ${selectedFilter === option.value ? 'active' : ''}`}
              onClick={() => handleClick(option.value)}
            >
              <NavLinkWrapper className={selectedFilter === option.value ? 'active' : ''}>
                {option.icon}
                <span>{option.label}</span>
              </NavLinkWrapper>
            </li>
          ))}

          {/* Requirement Accordion */}
          <CustomAccordionStyles>
            <Accordion defaultActiveKey="0" className="mt-3">
              <Accordion.Item eventKey="0" className="bg-transparent border-0">
                <Accordion.Header className="accord-text">
                  <AccordionHeaderWrapper>
                    <RequirementIcon />
                    <span>Requirement</span>
                  </AccordionHeaderWrapper>
                </Accordion.Header>
                <Accordion.Body className="p-0">
                  <Nav className="flex-column">
                    {requirementOptions.map((option) => (
                      <li
                        key={option.value}
                        className={`nav-item ${selectedFilter === option.value ? 'active' : ''}`}
                        onClick={() => handleClick(option.value)}
                      >
                        <NavLinkWrapper
                          className={`ps-4 requirement-item ${
                            selectedFilter === option.value ? 'active' : ''
                          }`}
                        >
                          {option.icon}
                          <span>{option.label}</span>
                        </NavLinkWrapper>
                      </li>
                    ))}
                  </Nav>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </CustomAccordionStyles>
        </ul>
      </div>
    </aside>
  );
};

export default SidebarCommon;